module.exports = __webpack_public_path__ + "img/logo.13800078.png";